import { useEffect } from "react";
import { BiChevronRight } from "react-icons/bi";
import { Link } from "react-router-dom";
import SmartServicesList from "./SmartServicesList"; // Remplacement
import { useServiceStore } from "../store/serviceStore";

const ExclusiveServices = () => {
  const { services, loadServices } = useServiceStore();

  useEffect(() => {
    loadServices();
  }, [loadServices]);

  return (
    <section className="bg-white/90 py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-end mb-8">
          <div>
            <span className="font-poppins font-medium text-[15px] text-[#444] bg-gray-100 px-2 py-1">
              Nos prestations
            </span>
            <h2 className="font-poppins font-semibold text-[18px] lg:text-[28px] text-[#222] mt-2">
              Services exclusifs
            </h2>
          </div>
          <Link
            to="/services"
            className="font-nunito font-semibold text-[14px] text-[#FF4081] hover:underline flex justify-center items-center gap-2"
          >
            <span>Voir tous nos services</span>
            <BiChevronRight />
          </Link>
        </div>

        {/* Utilisation du nouveau composant */}
        <SmartServicesList
          liste={services}
          thresholds={{
            veryLarge: 12,
            large: 8,
            medium: 4,
            small: 4,
          }}
          responsiveCols={{
            lg: 4,
            md: 3,
            sm: 1,
          }}
          search={true}
          searchPlaceholder="Rechercher parmi nos services exclusifs..."
          emptyMessage="Aucun service exclusif disponible pour le moment."
        />
      </div>
    </section>
  );
};

export default ExclusiveServices;

// import { useEffect } from "react";
// import { BiChevronRight } from "react-icons/bi";
// import { Link } from "react-router-dom";
// import ServicesListPaginated from "./ServicesListPaginated";
// import { useServiceStore } from "../store/serviceStore";

// const ExclusiveServices = () => {
//   const { services, loadServices } = useServiceStore();

//   useEffect(() => {
//     loadServices();
//   }, [loadServices]);

//   return (
//     <section className="bg-white/90 py-16 px-4">
//       <div className="max-w-7xl mx-auto">
//         <div className="flex justify-between items-end mb-8">
//           <div>
//             <span className="font-poppins font-medium text-[15px] text-[#444] bg-gray-100 px-2 py-1">
//               Nos prestations
//             </span>
//             <h2 className="font-poppins font-semibold text-[18px] lg:text-[28px] text-[#222] mt-2">
//               Services exclusifs
//             </h2>
//           </div>
//           <Link
//             to="/services"
//             className="font-nunito font-semibold text-[14px] text-[#FF4081] hover:underline flex justify-center items-center gp-2"
//           >
//             <span>Voir tous nos services</span>
//             <BiChevronRight />
//           </Link>
//         </div>

//         <ServicesListPaginated
//           liste={
//             Array.isArray(services) &&
//             services.filter((service) => service.is_active === true)
//           }
//           slice={4}
//           search={false}
//           filter={false}
//         />
//       </div>
//     </section>
//   );
// };

// export default ExclusiveServices;
